import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const homeownerPortalErrorTypeValues = ["TRPC_NON_JSON_RESPONSE"] as const;
const homeownerPortalErrorTypeSchema = z.enum(homeownerPortalErrorTypeValues);
const HomeownerPortalErrorType = homeownerPortalErrorTypeSchema.enum;
type HomeownerPortalErrorType = z.infer<typeof homeownerPortalErrorTypeSchema>;

export type HomeownerPortalErrors = {
  errorType: typeof HomeownerPortalErrorType.TRPC_NON_JSON_RESPONSE;
  data: {
    path: string;
    status: number;
    contentType: string | null;
    vercelError: string | null;
    requestId: string | null;
  };
};

export const homeownerPortalErrorDetails: Record<HomeownerPortalErrorType, ErrorDetails> = {
  [HomeownerPortalErrorType.TRPC_NON_JSON_RESPONSE]: {
    sentryDescription: "The server was temporarily unavailable. Please try again.",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
